/**
 * Single-thread PHP dev server: defer heavy fusion_history.php until
 * higher-priority endpoints (gex.php) finish.
 */

let inFlight = 0;

export function beginPhpPriorityRequest() {
  inFlight += 1;
}

export function endPhpPriorityRequest() {
  inFlight = Math.max(0, inFlight - 1);
}

export function withPhpPriority(promise) {
  beginPhpPriorityRequest();
  return Promise.resolve(promise).finally(endPhpPriorityRequest);
}

const delay = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); });

/**
 * Wait until no priority PHP requests are in flight.
 * graceMs: let RiskGraph mount and start gex after scan data arrives.
 */
export async function waitForPhpPriorityIdle({
  graceMs = 800,
  settleMs = 200,
  maxWaitMs = 30000,
} = {}) {
  const started = Date.now();
  await delay(graceMs);

  while (Date.now() - started < maxWaitMs) {
    if (inFlight === 0) {
      await delay(settleMs);
      if (inFlight === 0) return;
    }
    await delay(50);
  }
}
